function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { useRef } from 'react';
import EmailEditor from 'react-email-editor';
import Select from 'react-select';
import ReactDOM from 'react-dom';
import CommonModal from './CommonModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var options = [{
  value: 'send',
  label: 'Send'
}, {
  value: 'view',
  label: 'View as a Client'
}, {
  value: 'download',
  label: 'Download PDF'
}, {
  value: 'duplicate',
  label: 'Duplicate contract'
}, {
  value: 'delete',
  label: 'Delete contract'
}, {
  value: 'savetemplate',
  label: 'Save as a template'
}];
function Example(props) {
  var emailEditorRef = useRef(null);
  var saveButtonRef = useRef(null);
  var axios = require('axios')["default"];
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    contractId = _useState2[0],
    setcontractId = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    documentId = _useState4[0],
    setdocumentId = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    message = _useState6[0],
    setMessage = _useState6[1];
  var exportHtml = function exportHtml() {
    emailEditorRef.current.editor.exportHtml(function (data) {
      var design = data.design,
        html = data.html;
    });
  };

  // const saveTemplate = () => {
  //     emailEditorRef.current.editor.exportHtml((data) => {
  //         const { design, html } = data;
  //         emailEditorRef.current.editor.saveDesign(design => {
  //             axios.post('/save_contract_temp', {
  //                 content: design,
  //                 html: html,
  //                 contractId: contractId
  //             })
  //                 .then(function (response) {
  //                     // handle success
  //                     setMessage("Template saved successfully");
  //                     console.log(response, "responssssss");
  //                 })
  //                 .catch(function (error) {
  //                     // handle error
  //                     console.log(error);
  //                 })
  //                 .then(function () {
  //                     // always executed
  //                 });
  //         })
  //     })
  // };

  var onLoad = function onLoad() {
    // you can load your template here;
    // const templateJson = {};
    // emailEditorRef.current.editor.loadDesign(templateJson);
    axios.get('/contract/view_design/' + contractId).then(function (response) {
      // handle success
      // console.log(response.data,"html template conetnt");
      emailEditorRef.current.editor.loadDesign(response.data);
      // setTimeout(() => {
      //     saveButtonRef.current.click();
      // }, 500);
    })["catch"](function (error) {
      // handle error
      console.log(error);
    }).then(function () {
      // always executed
    });
  };
  var saveContractDesign = function saveContractDesign() {
    emailEditorRef.current.editor.exportHtml(function (data) {
      var design = data.design,
        html = data.html;
      emailEditorRef.current.editor.saveDesign(function (design) {
        axios.post('/contract/save_design', {
          content: design,
          html: html,
          contractId: contractId
        }).then(function (response) {
          // handle success
          setMessage("Template saved successfully");
          setTimeout(function () {
            setMessage("");
          }, 500);
        })["catch"](function (error) {
          // handle error
          console.log(error);
        }).then(function () {
          // always executed
        });
      });
    });
  };
  useEffect(function () {
    var id = document.getElementById('contractId').value;
    setcontractId(id);
  }, []);

  // Make saveContractDesign globally available for header button
  useEffect(function () {
    window.saveContractDesign = saveContractDesign;
    return function () {
      delete window.saveContractDesign;
    };
  }, [contractId, emailEditorRef]);
  useEffect(function () {
    var documentid = document.getElementById('documentId').value;
    setdocumentId(documentid);
  }, []);
  var handleChange = function handleChange(selectedOption) {
    // console.log(selectedOption);
    if (selectedOption.value == 'view') {
      window.open("/contract/" + documentId + "?user", 'blank');
    } else if (selectedOption.value == 'download') {
      window.location.href = "/download/" + contractId;
    } else if (selectedOption.value == 'delete') {
      openModal();
    } else if (selectedOption.value == 'duplicate') {
      window.location.href = "/contract/duplicate/" + documentId;
    } else if (selectedOption.value == 'send') {
      window.location.href = "/contract/send/" + documentId;
    } else if (selectedOption.value == 'savetemplate') {
      window.location.href = "/contract/save_contract_template/" + contractId;
    }
    // window.location.href = "/contract_design";
  };

  var subtitle;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    modalIsOpen = _React$useState2[0],
    setIsOpen = _React$useState2[1];
  function openModal() {
    setIsOpen(true);
  }

  // function afterOpenModal() {
  //     // references are now sync'd and can be accessed.
  //     subtitle.style.color = '#f00';
  // }

  function closeModal() {
    setIsOpen(false);
  }
  function success() {
    setIsOpen(false);
    window.location.href = "/contract/delete/" + documentId;
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(CommonModal, {
      isOpen: modalIsOpen,
      headerTitle: "Confirm",
      onClose: closeModal,
      onSuccess: success
    }), message && /*#__PURE__*/_jsx("div", {
      className: "result",
      style: {
        padding: '10px',
        color: 'green',
        fontWeight: 'bold'
      },
      children: message
    }), /*#__PURE__*/_jsx(EmailEditor, {
      minHeight: "calc(100vh - 145px)",
      tools: {
        menu: {
          enabled: false
        }
      },
      ref: emailEditorRef,
      onLoad: onLoad
    })]
  });
}
export default Example;